/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useContext } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  getPlazaDropdown,
  ETCReport,
  getETCConfig,
} from "../../../common/apiService";
import "../ETCReport/ETCReport.css";
import Select, { components } from "react-select";
import { UserContext } from "../../../contexts/UserContext";
import { toast } from "react-toastify";

export default function ETCReportScreen() {
  const userDetail = useContext(UserContext);
  const [plazaType, setPlazaType] = useState("");
  const [viewType, setViewType] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [plazaOptions, setPlazaOptions] = useState([]);
  const [loadingPlazas, setLoadingPlazas] = useState(false);
  const [selectedPlazas, setSelectedPlazas] = useState([]);
  const [loading, setLoading] = useState(false);

  const [plazaLimit, setPlazaLimit] = useState(5);
  const [rangeLimit, setRangeLimit] = useState(7);
  const [downloadType, setDownloadType] = useState("");

  const today = new Date().toISOString().split("T")[0];
  const reportNameMap = {
    acq: "Acquirer_Bank_View",
    si: "System_Integrator_View",
  };
  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await getETCConfig();
        if (response?.data) {
          setPlazaLimit(response.data.plazaLimit);
          setRangeLimit(response.data.rangeLimit);
        }
      } catch (error) {
        console.error("Error fetching ETC config:", error);
      }
    };

    fetchConfig();
    console.log("after call limits", rangeLimit, plazaLimit);
  }, []);

  const handlePlazaTypeChange = async (e) => {
    const value = e.target.value;
    setSelectedPlazas([]);
    setPlazaOptions([]);
    setPlazaType(value);

    if (!value) {
      setPlazaOptions([]);
      return;
    }

    try {
      setLoadingPlazas(true);
      const response = await getPlazaDropdown({
        plazaType: value,
        userType: userDetail.userType,
      });
      const data = response.data;

      const formatted = data.map((p) => ({
        value: p.plaza_id,
        label: `${p.plaza_name} (${p.plaza_id})`,
      }));

      setPlazaOptions(formatted);
    } catch (err) {
      console.error("Error fetching plazas:", err);
    } finally {
      setLoadingPlazas(false);
    }
  };

  const handlePlazaSelect = (selected) => {
    if (!selected) {
      setSelectedPlazas([]);
      return;
    }

    const groupPlazas = selected.filter((p) =>
      p.label?.toLowerCase().includes("group plaza")
    );

    if (groupPlazas.length > 1) {
      alert("Only one 'Group Plaza' can be selected.");
      return;
    }

    if (groupPlazas.length === 1 && selected.length > 1) {
      alert("Cannot select other plazas when a 'Group Plaza' is selected.");
      return;
    }

    const nonGroup = selected.filter(
      (p) => !p.label?.toLowerCase().includes("group plaza")
    );
    if (nonGroup.length > plazaLimit) {
      alert(`You can select up to ${plazaLimit} plazas only`);
      return;
    }

    setSelectedPlazas(selected);
  };

  const CheckboxOption = (props) => (
    <components.Option {...props}>
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={() => null}
        style={{ marginRight: 8 }}
      />
      <label>{props.label}</label>
    </components.Option>
  );

  const handleClear = () => {
    setViewType("");
    setPlazaType("");
    setStartDate("");
    setEndDate("");
    setSelectedPlazas([]);
    setPlazaOptions([]);
  };

  const handleDownload = async (type) => {
    setLoading(true);
    setDownloadType(type); // excel or csv

    if (!startDate || !endDate) {
      alert("Please select a valid date range before downloading.");
      setLoading(false);
      return;
    }
    if (!plazaOptions || plazaOptions.length === 0) { //if no valid option is there then no data 
      alert("No data available for selected filters.");
      setLoading(false);
      return;
    }
    const effectivePlazas = selectedPlazas.length > 0 ? selectedPlazas : plazaOptions; //this is if specific plaza is not selected, all in valid options will come 

    const payload = {
      viewType,
      plazaType,
      plazas: effectivePlazas,
      startDate,
      endDate,
      fileType: type, // send to backend
    };
    console.log("PAYLOAD TO BACKEND", payload);
    try {
      const response = await ETCReport(payload);
      if (!response.data || response.data.byteLength === 0 || response.status === 204) {
        alert("No data available for selected filters.");
        return;
      }
      const mimeType =
        type === "excel"
          ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          : "text/csv";

      const selectedReportName = reportNameMap[viewType] || "ETC_Report";
      const fileName =
        type === "excel"
          ? `${selectedReportName}.xlsx`
          : `${selectedReportName}.csv`;

      const blob = new Blob([response.data], { type: mimeType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", fileName);

      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
      alert("Failed to download report.");
    } finally {
      setLoading(false);
      setDownloadType("");
    }
  };
  const handleStartDateChange = (e) => {
    const newStart = e.target.value;
    setStartDate(newStart);
    setEndDate("");
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

  const validateEndDate = () => {
    if (startDate && endDate) {
      const diffDays = Math.floor((new Date(endDate) - new Date(startDate)) / (1000 * 60 * 60 * 24))+1;

      if (diffDays < 0) {
          alert('End date cannot be before start date');
          setEndDate("");
          return;
        }

      if (diffDays > rangeLimit) {
        alert(`Maximum allowed date range is ${rangeLimit} days.`);
        setEndDate("");
      }
    }
  };

  return (
    <div
      className="container mt-5 p-4 border rounded shadow-sm"
      style={{ maxWidth: "600px", backgroundColor: "white" }}
    >
      <h4 className="text-center mb-4 fw-bold text-danger">
        ETC TAT (SLA) Report
      </h4>

      {/* View Type */}
      <div className="mb-3">
        <label className="form-label fw-bold">Acquirer Type:  <span className="text-danger">*</span></label>
        <select
          className="form-select"
          value={viewType}
          onChange={(e) => setViewType(e.target.value)}
        >
          <option value="">Select Report Type</option>
          <option value="acq">Acquirer Bank View</option>
          <option value="si">System Integrator View</option>
        </select>
      </div>

      {/* Plaza Type */}
      <div className="mb-3">
        <label className="form-label fw-bold">Plaza Type:  <span className="text-danger">*</span></label>
        <select
          className="form-select"
          value={plazaType}
          onChange={handlePlazaTypeChange}
        >
          <option value="">Select Plaza Type</option>
          <option value="all">All Toll Plazas</option>
          <option value="National">National Toll Plazas</option>
          <option value="State">State Toll Plazas</option>
          <option value="Parking">Parking Toll Plazas</option>
        </select>
      </div>

      {/* Plaza Name Dropdown */}
      <div className="mb-3">
        <label className="form-label fw-bold">Plaza Name:</label>
        <Select
          isMulti
          isClearable
          isLoading={loadingPlazas}
          options={plazaOptions}
          value={selectedPlazas}
          onChange={handlePlazaSelect}
          placeholder={
            loadingPlazas ? "Fetching plaza list..." : "Select Plaza(s)"
          }
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          components={{ Option: CheckboxOption }}
          styles={{
            control: (base) => ({
              ...base,
              borderRadius: "8px",
              boxShadow: "none",
              borderColor: "#ccc",
              "&:hover": { borderColor: "#007bff" },
            }),
          }}
        />
      </div>

      {/* Date Range - 7 day Max */}
      <div className="mb-3">
        <label className="form-label fw-bold">Date Range:  <span className="text-danger">*</span></label>
        <div className="d-flex gap-2">
          <input
            type="date"
            className="form-control"
            value={startDate}
            onChange={handleStartDateChange}
            max={endDate || today}
          />
          <span className="align-self-center">to</span>
          <input
            type="date"
            className="form-control"
            value={endDate}
            onChange={handleEndDateChange}
            onBlur={validateEndDate} //validation done after selecting both
            min={startDate || today}
            max={today}
          />
        </div>
        <small className="text-muted">
          * Maximum {rangeLimit}-day range is allowed.
        </small>
      </div>

      {/* Download, Clear Buttons */}
      <div className="d-flex justify-content-between mt-4 flex-wrap gap-2 align-items-center">
        {["Clear", "Download Excel", "Download CSV"].map((label, i) => (
          <div key={i} className="d-flex align-items-center gap-2">
            <button
              className="btn flex-grow-1"
              style={{
                backgroundColor: "#8A1538",
                color: "white",
                border: "none",
                fontWeight: "bold",
                minWidth: "150px",
              }}
              onClick={() => {
                if (label === "Clear") handleClear();
                else if (label === "Download Excel") handleDownload("excel");
                else if (label === "Download CSV") handleDownload("csv");
              }}
              disabled={
                (label === "Download Excel" || label === "Download CSV") &&
                (loading || !viewType || !startDate || !endDate || !plazaType)
              }
            >
              {loading && label !== "Clear" ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Downloading...
                </>
              ) : (
                label
              )}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}